import { z } from "zod";

export const JwtTokenDataSchema = z.object({
  email: z.string(),
  family_name: z.string(),
  given_name: z.string(),
  name: z.string(),
  preferred_username: z.string(),
  realm_access: z.object({
    roles: z.string().array(),
  }),
  session_state: z.string(),
  sub: z.string(),
  "mapper-group-email": z.string().array().optional(),
});

export type JwtTokenDataType = z.infer<typeof JwtTokenDataSchema>;
